<template>
  <l-cache ref="cache" :get-data="getItem" :id="'newMessageClass'">
  <l-layout :layout="['xs12']" slot-scope="{data}">
    <v-card>
      <v-form ref="classForm">
        <v-layout justify-center column class="pa-3">
          <v-flex xs12>
            <v-text-field label="类型名称" prepend-icon="$vuetify.icons.title" v-model="form.name" :disabled="disabledFlag" :rules="[$rules.requiredS()]">
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea label="类型描述" prepend-icon="$vuetify.icons.comment" v-model="form.description" rows="1" auto-grow  :disabled="disabledFlag">
            </v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn class="primary" @click="submit" :loading="loading" :disabled="disabledFlag">提交</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </l-layout>
  </l-cache>
</template>

<script>
export default {
  name: 'newMessageClass',
  data () {
    return {
      loading: false,
      disabledFlag: false,
      form: {
        name: '',
        description: ''
      }
    }
  },
  methods: {
    async getItem () {
      return {}
    },
    async submit () {
      if (!this.$refs.classForm.validate()) {
        this.$L.alert('error', {message: '表单数据不合法'})
        return
      }
      let params = {
        name: this.form.name,
        description: this.form.description,
        value: ''
      }
      let url = '/messageApi/admin/addMsgLabelType'
      this.loading = true
      try {
        let res = await this.$store.dispatch('message/addActions', {params: params, url: url})
        if (res.data.code + '' === '200') {
          this.$L.alert('success', {message: '添加成功'})
          this.disabledFlag = true
          this.$store.commit('message/setClassRefresh', true)
        }
        else {
          this.$L.alert('error', {message: '添加失败，原因：' + res.data.msg})
        }
      }
      catch (e) {
        console.log(e)
      }
      finally {
        this.loading = false
      }
    }
  },
}
</script>

<style scoped>

</style>
